import React from 'react'
import { numberColumn } from 'components/DataTable'

export const loyaltycardList = (t, locales, { commonData }) => [
	{
		Header: <span className='sort-icons'>{t('common.fields.code')}</span>,
		accessor: 'id',
		width: 80,
		Footer: ({ data }) => <span>{commonData?.cashAssist?.listLoyaltyCards?.stats.count}</span>
	}, {
		Header: <span className='sort-icons'>{t('loyalty_card_section.fields.card_name')}</span>,
		accessor: 'name'
	}, {
		Header: <span className='sort-icons'>{t('loyalty_card_section.strings.balance')}</span>,
		accessor: 'balance',
		width: 80,
		...numberColumn(),
		Footer: () => <span>{commonData?.cashAssist?.listLoyaltyCards?.stats.balance}</span>
	}, {
		Header: t('loyalty_card_section.fields.points'),
		accessor: 'points',
		width: 90,
		style: {
			justifyContent: 'flex-end'
		},
		...numberColumn({ toFixed: 0, alignHeaderLeft: true }),
		Footer: () => <span>{commonData?.cashAssist?.listLoyaltyCards?.stats.points}</span>
	}, {
		// this is for query search
		accessor: 'barCode',
		show: false
	}, {
		// this is for query search
		accessor: 'phoneNumber',
		show: false
	}
]

export const loyaltycardTransactions = t => [
	{
		caption: t('common.fields.date'),
		localFormat: { type: 'date' },
		dataField: 'transactionDate'
	}, {
		caption: t('common.fields.time'),
		localFormat: { type: 'time' },
		calculateCellValue: data => data.transactionDate
	}, {
		caption: t('common.fields.name'),
		dataField: 'name'
	}, {
		caption: t('loyalty_card_section.strings.group'),
		dataField: 'group.name',
		visible: false
	}, {
		caption: t('common.fields.cash_register'),
		dataField: 'cashRegister.name',
		width: 200
	}, {
		caption: t('loyalty_card_section.strings.bill_number'),
		dataField: 'billNumber'
	}, {
		caption: t('loyalty_card_section.strings.user_name'),
		dataField: 'userName'
	}, {
		caption: t('loyalty_card_section.strings.credit'),
		dataField: 'increase',
		localFormat: { type: 'float' }
	}, {
		caption: t('loyalty_card_section.strings.charge'),
		dataField: 'decrease',
		localFormat: { type: 'float' }
	}, {
		caption: t('loyalty_card_section.fields.balance'),
		dataField: 'balance',
		localFormat: { type: 'float' }
	}, {
		caption: t('loyalty_card_section.fields.points'),
		dataField: 'points',
		localFormat: { type: 'float', precision: 0 }
	}, {
		caption: t('loyalty_card_section.strings.points_balance'),
		dataField: 'pointsTotal',
		localFormat: { type: 'float' }
	}, {
		caption: t('loyalty_card_section.strings.booking_mode'),
		dataField: 'mode',
		visible: false
	}, {
		caption: `${t('common.fields.cash_register')} ${t('common.fields.date')}`,
		localFormat: { type: 'date' },
		dataField: 'dateTime',
		visible: false
	}, {
		caption: `${t('common.fields.cash_register')} ${t('common.fields.time')}`,
		localFormat: { type: 'time' },
		calculateCellValue: data => data.dateTime,
		visible: false
	}, {
		dataField: 'isCancelled',
		visible: false
	}
]

export const loyaltycardHistory = [
	{
		Header: 'Datum',
		accessor: 'date'
	}, {
		Header: 'Zeit',
		accessor: 'time'
	}, {
		Header: 'Operation',
		accessor: 'action',
		width: 200
	}, {
		Header: 'Benutzername',
		accessor: 'username',
		width: 150
	}, {
		Header: 'Art',
		accessor: 'type',
		width: 200
	}
]

export const seriesCards = t => [
	{
		Header: t('common.fields.code'),
		accessor: 'id',
		width: 100
	}, {
		Header: t('loyalty_card_section.fields.card_name'),
		accessor: 'name'
	}
]
